
<template>
    <div>
      <div v-if="!isLogged" class="center-login-card">
        <SignIn v-if="!isLogged && !adminMode"></SignIn>
        <AdminSignIn v-if="!isLogged && adminMode"></AdminSignIn>
      </div>

        <b-container v-if="isLogged" class="px-0 mx-0 dashboard" fluid="true">
            <b-row class="px-0 mx-0" >

              <div class="col-12 app-viewport" :class="adminMode ? [] : [showLeftMenu ? 'open-left-menu' : 'hide-left-menu']">

                  <div class="menu-left-container d-none d-md-flex app-scroll-bar app-scroll-bar-vertical" style="z-index: 1010" v-if="!adminMode">
<!--                    <span>DESKTOP MENU</span>-->
                    <DesktopMenu></DesktopMenu>
                  </div>
                  <div :class="'app-content-container main-view-gradient ' + (adminMode ? 'w-100': '')" :style="'height: ' + heightOfScrollbarTable">
                    <ActivityWorkspace ref="activityWorkspace" baseRoute="/" ></ActivityWorkspace>
                  </div>

              </div>
              <guides v-if="sessionPreloaded"></guides>

            </b-row>
        </b-container>
      <footer v-if="isLogged" class="footer text-xxs" id="page-footer" style="z-index: 1010" :style="'width: ' + widthOfFooter">
        <b-container fluid="true" class="m-0 p-0">
          <b-row no-gutters class="align-items-center">
            <b-col cols="auto" :style="'color: ' + colorOfPlug">
              <font-awesome-icon icon="plug"  class=" ml-2"  />
            </b-col>

            <b-col  cols="auto"  class="text-left pl-md-2 app-login-user">
              <span style="margin-top: 2px" class="d-none d-md-inline badge badge-success" v-if="orgType === SUB_TYPE_ENTERPRISE|| plan === SILKPLM_STANDARD">Standard</span>
              <span style="margin-top: 2px" class="d-none d-md-inline badge badge-info" v-else-if="plan === SILKPLM_DESIGNER">Designer</span>
              <button @click="goToShop" style="margin-top: 2px" class="btn d-none d-md-inline badge badge-warning" v-else>Free - upgrade now!</button>
            </b-col>

            <b-col  cols="auto"  class="text-left pl-md-2 app-login-user">
              <span class="d-none d-md-inline">{{login}}</span>

              <span v-if="isDev" class="d-none d-sm-inline d-md-none pl-1">sm</span>
              <span v-if="isDev" class="d-none d-md-inline d-lg-none pl-1">md</span>
              <span v-if="isDev" class="d-none d-lg-inline d-xl-none pl-1">lg</span>
              <span v-if="isDev" class="d-none d-xl-inline  pl-1">xl</span>
            </b-col>
            <b-col cols="auto" class="pr-2 pl-2">
              <div :class="progressBarAnimation ? 'progress data-loading': 'progress'" data-test-path="loading-indicator" style="height: 8px; width: 100px; margin-top: 2px" @dblclick="openConsole">
                <div
                    class="progress-bar progress-bar-striped progress-bar-animated bg-info"
                    role="progressbar"
                    :style="progressBarAnimation === true ? 'width: 100%' : 'width: 0%'">
                </div>
              </div>
            </b-col>

            <b-col  cols="auto"  v-if="newVersion">
              <span class="d-md-none" style="color: red"><font-awesome-icon icon="box-open"></font-awesome-icon></span>
              <span class="d-none d-md-inline " style="color: red"> <font-awesome-icon icon="box-open"> </font-awesome-icon> {{$tr('dashboard.new.version','New version available, please refresh')}} </span>
            </b-col>

            <b-col class="text-right pl-2">

            </b-col>

            <b-col cols="auto" class="text-center pl-2 pr-2">
              <button type="button" class="btn btn-link p-0" @click="toggleDelayedTasks(false)" style="height: 24px; width: 32px">
                <font-awesome-icon icon="folder-arrow-down" transform="shrink-1 left-0 up-0"  />
              </button>
              <div class="notifications-bottom" data-test-path="notifications_bottom" style="z-index: 9999 !important;">
                <delayed-tasks-list :list-visible="showDelayedTask"></delayed-tasks-list>
              </div>
            </b-col>

            <b-col cols="auto">
              <ChatBotModal />
            </b-col>
          </b-row>
        </b-container>
      </footer>
      <Popup v-if="showBuyPopup" :popupStyle="popupStyle" :popupCanClose="popupCanClose" :popupMsg="popupMsg">
      </Popup>
    </div>
</template>

<script>

    import AdminSignIn from "@/admin/AdminSignIn";
    import SignIn from "@/components/SignIn";
    import SessionManager, {
      SILKPLM_DESIGNER, SILKPLM_FREE,
      SILKPLM_STANDARD,
      SUB_TYPE_ENTERPRISE,
      SUB_TYPE_OPEN
    } from "@/utils/SessionManager"
    import EventBus from "@/utils/EventBus";
    import Events from "@/utils/Events";
    import LeftNavbar from "@/components/dashboard/menu/LeftMenu";
    import ActivityWorkspace from "@/activity/ActivityWorkspace";
    import {addListener} from "resize-detector";
    import {getStatus} from "@/utils/WsPipe";
    import ActivityManager from "@/activity/ActivityManager";
    import ChatBotModal from "@/components/chatBot/ChatBotModal";
    import DesktopMenu from "@/components/dashboard/menu/DesktopMenu";
    import DelayedTasksList from "@/delayed/DelayedTasksList.vue";
    import ApplicationUser from "@/server/com/silkplm/model/users/ApplicationUser";
    import Guides from "@/components/dashboard/guides/Guides.vue";
    import {openAddSubscriptionPage} from "@/components/subscriptions/Subs";
    import Popup from "@/components/dashboard/Popup.vue";
    import {sendEvent} from "@/utils/GEvents";
    import sessionManager from "@/utils/SessionManager";


    export default {
      name: "Dashboard",
      components: {
        Popup,
        Guides,
        DelayedTasksList,
        ChatBotModal, ActivityWorkspace, LeftNavbar, SignIn, AdminSignIn, DesktopMenu},

      mounted() {
        if(SessionManager.configManager?.preloadedFinished){
          this.sessionPreloaded = true;
        } else {
          this.$onEvent("config-preloaded", ()=>{
            this.sessionPreloaded = true;
          });
        }

        this.$onEvent(Events.rpcLimits, (err) => {
          if(err.limitType === 'day'){
            this.popupMsg = "Your have reached your daily limit for this action, upgrade your plan or continue next day.";
          } else if(err.limitType === 'hour'){
            this.popupMsg = "Your have reached your hourly limit for this action, upgrade your plan or continue later.";
          } else if(err.limitType === 'minute'){
            this.popupMsg = "Your have reached your minute limit for this action, upgrade your plan or wait up to 1 minute.";
          } else {
            this.popupMsg = "This feature is not available in your plan. Upgrade your plan do continue.";
          }

          sendEvent("limit-popup-show");

          this.showBuyPopup = true;
        });

        this.$onEvent(Events.showBuyPlanPopup, () => {
          this.popupMsg = "";
          this.showBuyPopup = true;
        });

        this.$onEvent(Events.hideBuyPlanPopup, (popupConfig) => {
          this.popupMsg = "";
          this.showBuyPopup = false;
          this.popupStyle = popupConfig?.popupStyle ?? "upgrade";
          this.popupCanClose = popupConfig?.canClose ?? true;
        });

        this.$onEvent(Events.versionAvailable, () => {
            this.newVersion = true;
        });

        this.$onEvent(Events.toggleDelayedTasksList, () => {
          this.toggleDelayedTasks();
        });
        this.$onEvent(Events.showDelayedTasksList, () => {
          this.toggleDelayedTasks(true);
        });

        this.$onEvent(Events.showHideLeftMenu, () => {
          this.toggleLeftMenu();
        });

        this.$onEvent(Events.resetSubInfo, () => {
          this.plan = SessionManager.userSubscriptionType;
          this.orgType = SessionManager.organizationSubscriptionType;
        })

        addListener(document.getElementById('navbar-sizer'), () => this.fixSize())
        document.addEventListener("pagecontainershow", () => this.fixSize());
        window.addEventListener("resize", () => this.fixSize());
        window.addEventListener("orientationchange", () => this.fixSize());

        window.dispatchEvent(new Event('resize'));
        this.version = 'b:' + window['backendVersion'].version + "/f:" + window['_frontendVersion']
        window['__dashboard'] = this;

        this.plan = SessionManager.userSubscriptionType;
        let autoconf = SessionManager.configManager?.load("tour.autostart.autoconf");
        if (this.plan === SILKPLM_FREE && SessionManager.isProd() && !(autoconf === "supplier" || autoconf === "suppliers")) {
          this.popupCanClose = false;
          EventBus.$emit(Events.showBuyPlanPopup);
        }
        this.orgType = SessionManager.organizationSubscriptionType;
      },

      async beforeMount() {
        this.login = SessionManager.login;
        this.isLogged = SessionManager.isLoggedIn();


        this.$onEvent(Events.pushChannelConnected, () => {
          this.colorOfPlug = "green";
        });
        this.$onEvent(Events.pushChannelDisconnected, () => {
          this.colorOfPlug = "#dc3545";
        });
        this.$onEvent(Events.pushChannelFallback, () => {
          this.colorOfPlug = "#FFD700";
        });
        this.$onEvent(Events.rpcStart, () => {
          this.progressBarAnimation = true;
        });
        this.$onEvent(Events.rpcEnd, () => {
          this.$nextTick(() => {
            this.progressBarAnimation = false;
          });
        });
        this.$onEvent(Events.userSignedIn, login => {
          this.login = login;
        });
        this.$onUpdate(ApplicationUser, change => {
          if (change.instance.id === SessionManager.applicationUser.id) {
            this.login = change.instance.login
          }
        });
        this.$onEvent(Events.userSignedOut, () => {
          window.location.href="/dashboard/";
        });
        if(SessionManager.isLoggedIn()){
          this.initialStatusOfPlug();
          this.login = SessionManager.login;
          if(!SessionManager.isAdmin){
            let applicationUser = await Rpc.Users.getSessionUserInfo();
            if(applicationUser.shouldChangePassword){
              await DialogManager.getChangePasswordDialog();
            }
          }
        } else {
          this.login = '';
        }

        // eslint-disable-next-line no-unused-vars
        this.$onEvent(Events.userSignedIn, userEmail => {
          this.isLogged = true;
          setTimeout(() => this.fixSize());
        });
      },

      methods: {
        goToShop(){
          EventBus.$emit(Events.showBuyPlanPopup, {popupCanClose: true, popupStyle:"upgrade"})
        },

        toggleLeftMenu() {
          this.showLeftMenu = !this.showLeftMenu
        },

        toggleDelayedTasks(forceOn=false){
          this.showDelayedTask = !this.showDelayedTask || forceOn;
        },

        openConsole(){
            ActivityManager.console();
        },
        async fixSize(){
          window.requestAnimationFrame(() => {
            let footer = document.getElementById('page-footer');
            let heightOfFooter = footer ? footer.offsetHeight : 0;
            // console.log(`Footer ${heightOfFooter}`);
            let heightOfSmallNavbar = document.getElementById('navbar-sizer').offsetHeight;
            //this.heightOfScrollbarTable  = `calc(100vh - ${heightOfFooter}px - ${heightOfSmallNavbar}px)`;
            const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
            this.heightOfScrollbarTable  = `${vh - heightOfFooter - heightOfSmallNavbar}px`;
            let leftPanel = document.getElementById('left-navbar-panel');
            let widthOfLeftNavbar = leftPanel ? leftPanel.offsetWidth : 0;
            this.widthOfFooter = `calc(100vw - ${widthOfLeftNavbar}px`;

            if(this.$refs.activityWorkspace){
              this.$refs.activityWorkspace.sizeAdjusted(this.heightOfScrollbarTable);
            }
          });
        },

        initialStatusOfPlug(){
          this.statusOfPlug = getStatus();
          if(this.statusOfPlug === "connected")
            this.colorOfPlug = "green";
          else if(this.statusOfPlug === "disconnected")
            this.colorOfPlug = "#dc3545";
          else if(this.statusOfPlug === "fallback")
            this.colorOfPlug = "#FFD700";
        }
      },
      // watch:{
      //   login:function(val){
      //     console.log(val);
      //   }
      // },
      props: {
        adminMode:{default: false}
      },
      data: () => ({
        popupMsg: "",
        showBuyPopup: false,
        popupCanClose: true,
        popupStyle: 'upgrade',
        showDelayedTask:false,
        isDev: !SessionManager.isProd(),
        newVersion: false,
        showPopup: true,
        menuCollapsed: true,
        progressBarAnimation: false,
        statusOfPlug: "",
        colorOfPlug: "",
        sessionPreloaded: false,
        section: "dashboard",
        isLogged: false,
        heightOfScrollbarTable: "",
        widthOfFooter: "",
        login: "",
        plan: SessionManager.userSubscriptionType,
        orgType: SessionManager.organizationSubscriptionType,
        version: "?",
        SUB_TYPE_ENTERPRISE,
        SUB_TYPE_OPEN,
        SILKPLM_STANDARD,
        SILKPLM_DESIGNER,
        SILKPLM_FREE,
        showLeftMenu: true
      })
    };
</script>


<style>

  .app-viewport {
    padding: 0 !important;
  }

  @media(min-width: 768px) {
    .app-viewport {
      display: flex;
    }

    .menu-left-container {
      /*max-height: 100vh;*/
      max-height: calc(100vh - 71px);
      overflow-y: auto;
      white-space: nowrap;
      /*background-color: #6c828c;*/
    }

    .menu-left-container, .app-content-container {
      transition: width 0.3s ease-in-out;
    }

    .open-left-menu .menu-left-container {
      width: 250px;
      margin-left: 0;
    }

    .open-left-menu .app-content-container {
      margin-left: 0;
      width: calc(100% - 250px);
    }

    .hide-left-menu .menu-left-container {
      width: 0;
      margin-left: -250px;
    }

    .hide-left-menu .app-content-container {
      width: 100%;
      margin-left: 250px;
    }
  }


  #page-footer {
    z-index: 1;
    background-color: #224a66;
    color: white;
  }

  .app-login-user {
    display: flex;
    align-items: center;
  }


</style>

